import * as React from 'react';
import { createRoot } from 'react-dom/client';
import ProductReview from 'PyzShopUi/scripts/product-review/components/ProductReview';
import { IReviewSummary } from 'PyzShopUi/scripts/product-review/interfaces';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import {
    WritingProductReviewFormHandler
} from 'PyzShopUi/scripts/product-review/includes/WritingProductReviewFormHandler';
import { EDialogEvents } from 'PyzShopUi/scripts/modules/events/dialogEvent';
import { NAME_WRITING_PRODUCT_REVIEW_DIALOG } from 'PyzShopUi/scripts/product-review/constants/forms';
import { customerVerificationService } from 'PyzShopUi/scripts/product-review/services/CustomerVerificationService';
import { ETabEvent } from 'PyzShopUi/scripts/modules/events/tab.event';
import { EAccordionEvent } from 'PyzShopUi/scripts/modules/events/accordion.event';
import Loading from 'PyzShopUi/scripts/react/common/components/Loading';

export default class ProductReviewHandler {

    private static rootCreated = false;
    private static productReviewRoot;

    public static init = (): void => {
        const productReviewElement: HTMLElement = document.querySelector('.product-review-init');
        if (!productReviewElement) {
            return;
        }
        
        ProductReviewHandler.renderProductReview(productReviewElement);
        ProductReviewHandler.onClickDetailPageProductRating(productReviewElement);
        ProductReviewHandler.writingProductReviewFormListener();
        ProductReviewHandler.onClickOpeningTermProductReviewDialog();
        //delay opening dialog due to filter_article_number redirection on load
        setTimeout(() => ProductReviewHandler.onLoadOpeningProductReviewDialog(productReviewElement), 500);
    };

    private static renderProductReview = (productReviewElement: HTMLElement) => {
        const dataset = productReviewElement.dataset;
        const reviewSummary: IReviewSummary = JSON.parse(dataset.reviewSummary);
        const abstractSku: string = JSON.parse(dataset.abstractSku);

        if (!ProductReviewHandler.rootCreated) {
            const productReviewElementRoot = createRoot(productReviewElement);
            ProductReviewHandler.productReviewRoot = productReviewElementRoot;
        }

        ProductReviewHandler.productReviewRoot.render(
            <React.Suspense fallback={<Loading />}>
                <ProductReview
                    reviewSummary={reviewSummary}
                    abstractSku={abstractSku}
                />
            </React.Suspense>

        );

        ProductReviewHandler.rootCreated = true;
    }

    private static onClickDetailPageProductRating = (productReviewElement: HTMLElement) => {
        try {
            const headerElement: HTMLElement = productReviewElement.closest('.accordion-content')
                .previousElementSibling as HTMLElement;
            const productRatingElement: HTMLElement = document.querySelector('.article-main-info .product-rating-container');

            if (!headerElement.classList.contains('accordion-header') || !productRatingElement) {
                return;
            }

            const eventBus: EventBus = EventBus.getInstance();
            productRatingElement.addEventListener('click', (): void => {
                eventBus.publish(ETabEvent.OPEN, headerElement);
                eventBus.publish('scrolling:scrollTo', { target: headerElement });
                eventBus.publish(EAccordionEvent.OPEN, headerElement);
            });

            productRatingElement.addEventListener('keydown', (e): void => {
                if (e.key === 'Enter') {
                    eventBus.publish(ETabEvent.OPEN, headerElement);
                    eventBus.publish('scrolling:scrollTo', { target: headerElement });
                    eventBus.publish(EAccordionEvent.OPEN, headerElement);
                }
            });
        } catch (e) {
            return;
        }
    };

    private static writingProductReviewFormListener = () => {
        EventBus.getInstance().subscribe(EDialogEvents.OPEN_DIALOG, target => {
            if (target.id !== NAME_WRITING_PRODUCT_REVIEW_DIALOG) {
                return;
            }

            WritingProductReviewFormHandler.getInstance().initForm();
        });
    };

    private static onClickOpeningTermProductReviewDialog = () => {
        const termOfUseElement: HTMLElement = document.querySelector('.open-product-review-term-of-use');

        if (!termOfUseElement) {
            return;
        }

        termOfUseElement.addEventListener('click', function(event) {
            event.stopPropagation();
            event.preventDefault();

            EventBus.getInstance().publish(EDialogEvents.OPEN_DIALOG, { id: 'term-product-review-dialog' });
        });
    };

    private static onLoadOpeningProductReviewDialog = (productReviewElement: HTMLElement) => {
        if (!customerVerificationService.isValid()) {
            return;
        }

        try {
            const headerElement: HTMLElement = productReviewElement.closest('.accordion-content')
                .previousElementSibling as HTMLElement;
            const productRatingElement: HTMLElement = document.querySelector('.article-main-info .product-rating-container');

            if (!headerElement.classList.contains('accordion-header') || !productRatingElement) {
                return;
            }

            const eventBus: EventBus = EventBus.getInstance();
            eventBus.publish(ETabEvent.OPEN, headerElement);
            eventBus.publish('scrolling:scrollTo', { target: headerElement });
            eventBus.publish(EAccordionEvent.OPEN, headerElement);
            eventBus.publish(EDialogEvents.OPEN_DIALOG, {id: NAME_WRITING_PRODUCT_REVIEW_DIALOG});
        } catch (e) {
            console.log(e);
            return;
        }
    }
}
